import React from 'react';

import svg from './assets/icons-36-instagram.svg';
import type { IconProps } from './SvgIcon';
import { SvgIcon } from './SvgIcon';

export const IconInstagram = (props: IconProps) => (
  <SvgIcon {...props} src={svg} testId="icon-instagram" />
);
